<template>
  <div class=" ">
    <v-layout>
      <v-flex>
        <section>
          <v-card flat>
            <v-card-text class="pa-0">

              <v-row 
                style="height: 100vh;">
                <v-col 
                  cols="12"
                  md="5"
                  class="pl-9">
                  <v-card class="" flat style="background: #240087; border-radius: 16px;" height="100%">
                    <v-card-text class="pa-10" style="height: 100%;">
                      <div>
                        <div>
                          <div class="mb-12">
                            <v-img
                              src="@/assets/logo/Logo.png"
                              contain
                              style="width: 273px; height: 40px;">
                            </v-img>
                          </div>
                          <div>
                            <div class="fs-32 white--text font-weight-bold mb-6">
                              Integrated Point Of Sales
                            </div>
                            <div class="fs-15 white--text">
                              Layanan Sistem Informasi Manajemen Terintegrasi dalam mengelola dan mengembangkan Usaha Anda.
                            </div>
                          </div>
                        </div>
                        <div class="mt-16 pt-16">
                          <v-img
                            src="@/assets/image/img_login.png"
                            contain>
                          </v-img>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col 
                  cols="12"
                  md="7"
                  style="height: 100%; display: flex; align-items: center; justify-content: center;">
                  <v-card
                    flat
                    style="width: 500px;">
                    <div>
                      <v-card
                        flat
                        color="#FFFFFFB2"
                        class="border-radius">
                        <v-card-text
                          class="pa-0">
                          <div
                            class="mb-6">
                            <div
                              class="fs-30 black_one font-weight-bold black--text mb-12">
                              Masuk
                            </div>
                          </div>
    
                          <ValidationObserver 
                            ref="observer">
                            <v-form class="text-left mb-0">
                              <div class="fs-14 mb-1 black_two">
                                Email / Nomor Handphone
                              </div>
                              <ValidationProvider 
                                name="Email" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Masukan email atau nomor handphone yang telah didaftarkan"
    
                                  vv-uppercase
    
                                  v-model="form.username"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
    
                              <div class="fs-14 mb-1 black_two">
                                Kata Sandi
                              </div>
                              <ValidationProvider 
                                name="password" 
                                rules="required|min:5|max:30" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Masukan kata sandi"
                                  :type="show ? 'text' : 'password'"
                                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                  @click:append="show = !show"
                                  :counter="30"
    
                                  vv-uppercase
                                  
                                  v-model="form.password"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
                            </v-form>
                          </ValidationObserver>
    
                          <div 
                            class="text-center mb-6">
                            <div v-if="message.error.length > 0"
                              class="text-center my-4">
                              <div
                                class="error--text d-flex align-start">
                                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.error }}
                                </span>
                              </div>
                            </div>
    
                            <!-- <div class="blue_one fs-14 text-right mt-1 mb-5" style="font-weight: 600;">
                              <span class="cursor-pointer">Lupa Kata Sandi</span>
                            </div> -->
    
                            <v-btn
                              :disabled="process.form"
                              :loading="process.form"
                              @click="save()"
                              block
                              color="#240087"
                              width="170"
                              height="40"
                              elevation="0"
                              class="title font-weight-bold white--text text-capitalize border-radius">
                              Masuk
                            </v-btn>
    
                            <div class="text-center fs-14 my-10">
                              <span class="black_two">Belum punya akun? </span>
                              <span class="blue_one cursor-pointer" @click="toRegister()">Daftar</span>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web',
          fcm_token: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {
      toRegister() {
        this.$router.push('/register/informasi-user')
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          // this.form.fcm_token = this.$store.state.fcm

          await post('pos/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              console.log(res.results.data)
              let user = res.results.data,
                  menu_arr = res.results.data.cat_menu_arr.length < 1 ? [] : JSON.parse(res.results.data.cat_menu_arr),
                  menu_default = [
                  {
                    id: 1,
                    label: "Dashboard",
                    icon: "mdi-view-dashboard",
                    link: "/dashboard",
                    sub_menu:[]
                  },
                  {
                    id: 22,
                    label: "Data Pelanggan",
                    icon: "mdi-account-group",
                    link: "/pelanggan"
                  },
                  {
                    id: 45,
                    label: "Member E-Katalog",
                    icon: "mdi-account-multiple-outline",
                    link: "/member"
                  },
                  {
                    id: 28,
                    label: "Data Keuangan",
                    icon: "mdi-cash-multiple",
                    link: "/keuangan"
                  },
                  {
                    id: 2,
                    label: "Hak Akses",
                    icon: "mdi-shield-key",
                    link: "/category-user",
                    sub_menu:[]
                  },
                  {
                    id: 3,
                    label: "Pengguna",
                    icon: "mdi-account",
                    link: "/user",
                    sub_menu:[]
                  },
                  {
                    id: 4,
                    label: "Master Pembelian",
                    icon: "mdi-file-cog",
                    link: "/master-pembelian",
                    sub_menu: [
                      {
                          id: 5,
                          label: "Data Satuan",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/satuan",
                        },
                        {
                          id: 6,
                          label: "Data Kategori",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/kategori-item",
                        },
                        {
                          id: 7,
                          label: "Data Item",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/item",
                        },
                        {
                          id: 9,
                          label: "Data Bagian",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/lokasi",
                        },
                        {
                          id: 8,
                          label: "Data Supplier",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/supplier",
                        }
                      ]
                  },
                  {
                    id: 10,
                    label: "Pembelian",
                    icon: "mdi-cart",
                    link: "/pembelian",
                    sub_menu: [
                      {
                        id: 11,
                        label: "Permintaan",
                        icon: "mdi-cart",
                        link: "/pembelian/permintaan",
                      },
                      {
                        id: 42,
                        label: "Approval Permintaan",
                        icon: "mdi-cart",
                        link: "/pembelian/approval-permintaan",
                      },
                      {
                        id: 12,
                        label: "Pengadaan",
                        icon: "mdi-cart",
                        link: "/pembelian/pengadaan",
                      },
                      {
                        id: 13,
                        label: "Penerimaan",
                        icon: "mdi-cart",
                        link: "/pembelian/penerimaan",
                      },
                      {
                        id: 14,
                        label: "Persediaan",
                        icon: "mdi-cart",
                        link: "/pembelian/persediaan",
                      }
                    ]
                  },
                  {
                    id: 16,
                    label: "Master penjualan",
                    icon: "mdi-printer-pos-cog-outline",
                    link: "/master-penjualan",
                    sub_menu: [
                    {
                        id: 15,
                        label: "Data Satuan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/satuan",
                      },
                    {
                        id: 17,
                        label: "Kategori Produk",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/produk",
                      },
                      {
                        id: 18,
                        label: "Kategori Layanan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/layanan",
                      },
                      {
                        id: 19,
                        label: "Kategori Paket",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/paket",
                      },
                      {
                        id: 20,
                        label: "Data Produk",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-product",
                      },
                      {
                        id: 49,
                        label: "Data Topping",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-topping",
                      },
                      {
                        id: 38,
                        label: "Data Layanan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-layanan",
                      },
                      {
                        id: 21,
                        label: "Data Paket",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-paket",
                      },
                      {
                        id: 27,
                        label: "Tipe Penjualan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/type-penjualan"
                      },
                      // {
                      //   id: 37,
                      //   label: "Banner",
                      //   icon: "mdi-printer-pos-cog-outline",
                      //   link: "/master-penjualan/banner"
                      // }
                    ]
                  },
                  // {
                  //   id: 21,
                  //   label: "Item Sales",
                  //   icon: "mdi-package-variant-closed",
                  //   link: "/item-sales",
                  //   sub_menu:[
                  //     {
                  //       id: 22,
                  //       label: "Produk & Layanan",
                  //       icon: "mdi-package-variant-closed",
                  //       link: "/item-sales/product",
                  //     },
                  //     {
                  //       id: 23,
                  //       label: "Paket",
                  //       icon: "mdi-package-variant-closed",
                  //       link: "/item-sales/paket",
                  //     }
                  //   ]
                  // },
                  
                  {
                    id: 23,
                    label: "Shift Kasir",
                    icon: "mdi-printer",
                    link: "/shift-kasir",
                    sub_menu:[]
                  },
                  // {
                  //   id: 29,
                  //   label: "Tipe Penjualan",
                  //   icon:"mdi-percent-box",
                  //   link: "/type-penjualan",
                  //   sub_menu:[]
                  // },
                  {
                    id: 24,
                    label: "Transaksi",
                    icon: "mdi-cash",
                    link: "/sales-order",
                    sub_menu:[
                      {
                        id: 44,
                        label: "Transaksi Pesanan",
                        icon: "mdi-cash",
                        link: "/sales-order/pesanan",
                      },
                      {
                        id: 25,
                        label: "Transaksi Berlangsung",
                        icon: "mdi-cash",
                        link: "/sales-order/berlangsung",
                      },
                      {
                        id: 26,
                        label: "Transaksi Selesai",
                        icon: "mdi-cash",
                        link: "/sales-order/selesai",
                      },
                      {
                        id: 43,
                        label: "Transaksi Dihapus",
                        icon: "mdi-cash",
                        link: "/sales-order/hapus",
                      },
                      {
                        id: 46,
                        label: "Transaksi Pesanan Ditolak",
                        icon: "mdi-cash",
                        link: "/sales-order/pesanan-ditolak",
                      },
                      {
                        id: 47,
                        label: "Transaksi Verifikasi Pembayaran",
                        icon: "mdi-cash",
                        link: "/sales-order/verifikasi-pembayaran",
                      },
                      {
                        id: 48,
                        label: "Transaksi Ditolak",
                        icon: "mdi-cash",
                        link: "/sales-order/transaksi-ditolak",
                      }
                    ]
                  },
                  {
                    id: 29,
                    label: "Laporan",
                    icon: "mdi-file-chart-outline",
                    link: "/report",
                    sub_menu:[
                      {
                        id: 30,
                        label: "Laporan Penjualan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/harian",
                      },
                      {
                        id: 36,
                        label: "Penjualan Per Produk",
                        icon: "mdi-file-chart-outline",
                        link: "/report/varian",
                      },
                      { 
                        id: 31,
                        label: "Penjualan Per Kategori",
                        icon: "mdi-file-chart-outline",
                        link: "/report/kategori",
                      },
                      {
                        id: 33,
                        label: "Penjualan Per Pelanggan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/pelanggan",
                      },
                      {
                        id: 35,
                        label: "Penjualan Per Tipe Penjualan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/tipe-penjualan",
                      },
                      {
                        id: 32,
                        label: "Penjualan Per Metode Pembayaran",
                        icon: "mdi-file-chart-outline",
                        link: "/report/metode-pembayaran",
                      },
                      {
                        id: 34,
                        label: "Penjualan Riwayat Transaksi Pelanggan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/riwayat-transaksi",
                      }
                    ]
                  },
                  {
                    id: 39,
                    label: "Konfigurasi",
                    icon: "mdi-file-cog",
                    link: "/konfigurasi",
                    sub_menu: [
                      {
                        id: 40,
                        label: "import Produk",
                        icon: "mdi-file-cog",
                        link: "/konfigurasi/import-product"
                      },
                      {
                        id: 41,
                        label: "Konfigurasi Outlet",
                        icon: "mdi-file-cog",
                        link: "/konfigurasi/outlet"
                      }
                    ]
                  }
                  // {
                  //   id: 15,
                  //   label: "Master Data",
                  //   icon: "mdi-cog-outline",
                  //   link: "/master",
                  //   sub_menu: [
                  //     {
                  //       id: 16,
                  //       label: "Data Satuan",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/satuan",
                  //     },
                  //     {
                  //       id: 24,
                  //       label: "Data Pelanggan",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/pelanggan"
                  //     },
                  //     {
                  //       id: 29,
                  //       label: "Tipe Penjualan",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/type-penjualan"
                  //     },
                  //     {
                  //       id: 30,
                  //       label: "Data Bank",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/bank"
                  //     },
                  //   ]
                  // }
                  ],
                  menu_default_superuser = [
                    // {
                    //   label: "Dashboard",
                    //   icon: "mdi-view-dashboard",
                    //   link: "/dashboard",
                    // },
                    {
                      label: "Perusahaan",
                      icon: "mdi-newspaper-variant-outline",
                      link: "/perusahaan",
                    },
                    {
                      label: "Outlet",
                      icon: "mdi-store",
                      link: "/outlet",
                    },
                    {
                      label: "Jenis Usaha",
                      icon: "mdi-store-cog",
                      link: "/jenis-usaha",
                    },
                    {
                      label: "Banner",
                      icon: "mdi-image-multiple",
                      link: "/banner",
                    },
                  ]
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : user.cat_title === 'Super User' ? menu_default_superuser : menu_default)
              )

              TokenService.saveReload(false)

              TokenService.saveColor(
                '#240087'
              )

              this.$store.commit("setColor", '#240087')

              if (user.cat_title !== 'Super User' && user.cat_title !== 'Owner' && user.outlet_arr.length > 0) {
                let outlet = user.outlet_arr.filter(x => x.outlet_id === user.outlet_id)
                TokenService.saveOutlet(
                  JSON.stringify(outlet[0])
                )

                this.$store.commit("setOutlet", outlet[0])
              } 


              // console.log(res.results.data)
              // console.log(user.outlet_arr.filter(x => x.outlet_id === user.outlet_id))

              window.location = user.cat_title === 'Super User' ? `${process.env.BASE_URL}perusahaan` : user.cat_title === 'Owner' ? `${process.env.BASE_URL}pilih-outlet` : `${process.env.BASE_URL}dashboard`
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>